export const FLOATING_WHATSAPP_STYLE_DEFAULTS = Object.freeze({
  backgroundColor: "#25D366",
  iconColor: "#FFFFFF",
  borderColor: "transparent",
  borderWidth: 0,
  borderRadius: 999,
  boxShadow: "0 8px 28px rgba(0,0,0,.3)",
  size: 56,
  hover: Object.freeze({
    backgroundColor: "#1EBE5D",
    iconColor: "#FFFFFF",
    borderColor: "transparent",
    boxShadow: "0 8px 28px rgba(0,0,0,.3)",
  }),
});

function finite(value, fallback, min, max) {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(max, Math.max(min, number));
}

function ownString(value, fallback) {
  const candidate = String(value ?? "").trim();
  return candidate || fallback;
}

export function normalizeFloatingWhatsappStyle(value = {}) {
  const source = value && typeof value === "object" && !Array.isArray(value) ? value : {};
  const hover = source.hover && typeof source.hover === "object" && !Array.isArray(source.hover) ? source.hover : {};
  return {
    backgroundColor: ownString(source.backgroundColor, FLOATING_WHATSAPP_STYLE_DEFAULTS.backgroundColor),
    iconColor: ownString(source.iconColor, FLOATING_WHATSAPP_STYLE_DEFAULTS.iconColor),
    borderColor: ownString(source.borderColor, FLOATING_WHATSAPP_STYLE_DEFAULTS.borderColor),
    borderWidth: finite(source.borderWidth, FLOATING_WHATSAPP_STYLE_DEFAULTS.borderWidth, 0, 16),
    borderRadius: finite(source.borderRadius, FLOATING_WHATSAPP_STYLE_DEFAULTS.borderRadius, 0, 999),
    boxShadow: ownString(source.boxShadow, FLOATING_WHATSAPP_STYLE_DEFAULTS.boxShadow),
    size: finite(source.size, FLOATING_WHATSAPP_STYLE_DEFAULTS.size, 40, 96),
    hover: {
      backgroundColor: ownString(hover.backgroundColor, FLOATING_WHATSAPP_STYLE_DEFAULTS.hover.backgroundColor),
      iconColor: ownString(hover.iconColor, FLOATING_WHATSAPP_STYLE_DEFAULTS.hover.iconColor),
      borderColor: ownString(hover.borderColor, FLOATING_WHATSAPP_STYLE_DEFAULTS.hover.borderColor),
      boxShadow: ownString(hover.boxShadow, FLOATING_WHATSAPP_STYLE_DEFAULTS.hover.boxShadow),
    },
  };
}

export function floatingWhatsappButtonSx(value = {}) {
  const style = normalizeFloatingWhatsappStyle(value);
  return {
    width: style.size,
    height: style.size,
    minWidth: style.size,
    minHeight: style.size,
    borderRadius: `${style.borderRadius}px`,
    backgroundColor: style.backgroundColor,
    color: style.iconColor,
    border: `${style.borderWidth}px solid ${style.borderColor}`,
    boxShadow: style.boxShadow,
    "&:hover": {
      backgroundColor: style.hover.backgroundColor,
      color: style.hover.iconColor,
      borderColor: style.hover.borderColor,
      boxShadow: style.hover.boxShadow,
      transform: "translateY(-2px)",
    },
  };
}
